import {Injectable} from '@angular/core';
import {ApiService} from './api/api.service';
import {CheckpointComment} from '../classes/checkpoint-comment';

@Injectable({
    providedIn: 'root'
})
export class CheckpointCommentService {

    constructor(public apiService: ApiService) {
    }

    getCheckpointComment(id: number) {
        return this.apiService.getCallData$<CheckpointComment>(`checkpoints/comments/show/${id}`);
    }

    getCheckpointComments(checkpointId: number) {
        return this.apiService.getCallData$<CheckpointComment[]>(`checkpoints/comments/${checkpointId}`);
    }

    saveCheckpointComment(checkpointComment: CheckpointComment) {
        return this.apiService.postCall$<CheckpointComment>(`checkpoints/comments`, checkpointComment);
    }

    deleteCheckpointComment(id: number) {
        return this.apiService.deleteCall(`checkpoints/comments/${id}`);
    }
}
